import { ParamIds, Places } from '../../../../Constants'
import GroupManagerKeys from '../gm_keys'

export class GroupManagerFormKeys extends GroupManagerKeys {
    get place() {
        return Places.groupManagerForm
    }

    get groupId() {
        return this._intent.getParameterAsNumber(ParamIds.groupId)
    }

    set groupId(value: number | undefined) {
        this._intent.setParameter(ParamIds.groupId, value)
    }
}
